import React from "react";
import {Allow, policyEvents} from "../../../../Components/Authorize";
import {
    ButtonIconApprove,
    ButtonIconDelete,
    ButtonIconPackingList,
    ButtonIconProgress,
} from "../../../../Components/Inputs/Buttons/ButtonIcon/ButtonIcon";
import {LOAN_STATUS} from "./loanConstants";

interface LoanQueueRowProps {
    handleDelete: () => void;
    handleLoan: () => void;
    handlePacking: () => void;
    loan: Record<string, any>;
}

export const LoanQueueRow = ({
                                 handleDelete,
                                 handleLoan,
                                 handlePacking,
                                 loan
                             }: LoanQueueRowProps) => {

    return (
        <tr id={loan.id}>
            <td>
                {loan.dateRequested}
            </td>
            <td>
                {loan.title}
                {loan.volumeRange ? ` ${loan.volumeRange}` : ""}
            </td>
            <td>
                {loan.shelfLocation ? loan.shelfLocation : "Not Assigned"}
            </td>
            <td>
                {loan.barCode ? loan.barCode : "Not Assigned"}
            </td>
            <td>
                {loan.patron}
            </td>
            <td>
                {loan.shippingLocation}
            </td>
            <td>
                {loan.needFromFormatted ? loan.needFromFormatted : "Not Assigned"}
            </td>
            <td>
                {loan.student}
            </td>
            <td>
                {loan.loanStatusText}
            </td>

            <td className={`align-center`}>
                <Allow policyEvent={policyEvents.MANAGE_LOANS}>
                    {
                        loan.loanStatus !== LOAN_STATUS.ApproveForCheckout &&
                        handleLoan &&
                        <>
                            <ButtonIconProgress
                                inputDescription={`for ${loan.itemName}`}
                                onClick={handleLoan}
                            />
                            <ButtonIconPackingList
                                inputDescription={`for ${loan.itemName}`}
                                onClick={handlePacking}
                            />
                        </>
                    }
                    {
                        loan.loanStatus === LOAN_STATUS.ApproveForCheckout &&
                        <>
                            {
                                handleLoan &&
                                <ButtonIconApprove
                                    inputDescription={`for ${loan.itemName}`}
                                    onClick={handleLoan}
                                />
                            }
                            {
                                handleDelete &&
                                <ButtonIconDelete
                                    inputDescription={`for ${loan.itemName}`}
                                    onClick={handleDelete}
                                />
                            }
                        </>
                    }
                </Allow>
            </td>
        </tr>
    );
};